(() => {
  if (window.OkviriContact) return;
  const labels = {email:'E-mail',facebook:'Facebook',instagram:'Instagram'};
  const read = root => {
    const value = root.querySelector('[data-ok-contact] input:checked')?.value;
    return Object.hasOwn(labels,value) ? value : 'email';
  };
  const properties = root => ({'Kanal za kontakt':labels[read(root)],'_ok_contact_method':read(root)});
  const saveCart = async root => {
    const response = await fetch((window.Shopify?.routes?.root || '/')+'cart/update.js', {
      method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},
      body:JSON.stringify({attributes:{'Kanal za kontakt':'',ok_contact_method:'',ok_contact_language:''}})
    });
    if (!response.ok) throw new Error(document.documentElement.lang.startsWith('en')?'Your contact preference could not be saved. Please try again.':'Odabir kontakta nije moguće spremiti. Pokušaj ponovno.');
  };
  const start = '[O’kviri — detalji okvira]';
  const end = '[/O’kviri]';
  const meaningful = value => value && !['—','Nije odabran','Nije naveden','Not selected','Not specified'].includes(String(value).trim());
  const records = cart => {
    const value=cart.attributes?.ok_frame_details;
    if(!value)return {};
    try {const parsed=JSON.parse(value);if(!parsed || Array.isArray(parsed) || typeof parsed!=='object')throw Error();return parsed;}
    catch {throw new Error('Detalje okvira nije moguće pročitati. Javi nam se prije nastavka.');}
  };
  const get = (p,...keys) => keys.map(key=>p[key]).find(meaningful) || '';
  const describe = p => {
    const people=Object.entries(p).filter(([key,value])=>/^(Figurica|Figure) \d+$/.test(key)&&meaningful(value)).map(([key,value])=>key+': '+value);
    const text=[get(p,'Tekst na okviru','Ideja i opisi figurica'),...people].filter(Boolean).join('\n');
    const lines=[
      'Broj figurica: '+get(p,'Broj figurica'),
      'Boja okvira: '+(get(p,'Boja okvira')||'Dogovor prema ideji'),
      'Veličina okvira: '+(get(p,'Veličina okvira')||'25 × 25 cm'),
      'Tekst i opisi figurica: '+(text||'Prema odabranom dizajnu'),
      'Kasica: '+(get(p,'Kasica')||'Ne'),
      'Natpis na staklu: '+(get(p,'Tekst na staklu','Natpis na staklu')||'Ne'),
      'Rok: '+(get(p,'Željeni datum','Rok')||'Nije naveden'),
      'Način kontakta: '+(get(p,'Kanal za kontakt','Način kontakta')||labels[p._ok_contact_method]||'E-mail')
    ];
    for(const key of ['Paspartu','Prigoda','Dodatni rekviziti','Ljubimci','Napomena'])if(meaningful(p[key])&&!/^(Bez dodatnih rekvizita|Bez ljubimaca|No extra props|No pets)$/.test(p[key]))lines.push(key+': '+p[key]);
    if(p['_Pregled dizajna'])lines.push('Pregled dizajna: '+p['_Pregled dizajna']);
    return lines.join('\n');
  };
  const totals = items => items.reduce((map,item)=>{const id=String(item.variant_id||item.id);map[id]=(map[id]||0)+item.quantity;return map;},{});
  const activeRecords = cart => {
    const saved=records(cart),pool=totals(cart.items.filter(item=>!item.properties?._ok_group&&!item.properties?._Grupa)),active=[];
    for(const [group,record] of Object.entries(saved)){
      const matching=cart.items.find(item=>(item.properties?._ok_group||item.properties?._Grupa)===group&&String(item.variant_id||item.id)===String(record.baseVariant));
      if(matching){active.push({group,record,quantity:matching.quantity});continue;}
      const id=String(record.baseVariant),available=pool[id]||0;
      if(!available)continue;
      const count=Object.values(saved).filter(r=>String(r.baseVariant)===id).length;
      const quantity=count===1?available:Math.min(available,record.quantity||1);
      pool[id]-=quantity;active.push({group,record,quantity});
    }
    return active;
  };
  const summary = cart => {
    const blocks=activeRecords(cart).map(({record,quantity},index)=>'Okvir '+(index+1)+': '+record.title+(quantity>1?' ('+quantity+' kom.)':'')+'\n'+describe(record.properties));
    const saved=records(cart);
    for(const item of cart.items){const p=item.properties||{},group=p._ok_group||p._Grupa;
      if(saved[group])continue;
      if(p['Broj figurica']!==undefined||p['Ideja i opisi figurica']!==undefined)blocks.push('Okvir '+(blocks.length+1)+': '+(p.Dizajn||'Po tvojoj ideji')+'\n'+describe(p));
      else if(group&&Object.keys(p).length===1)throw new Error('Nedostaju spremljeni detalji okvira. Javi nam se prije nastavka.');
    }
    return blocks.join('\n\n');
  };
  const restoreCart = async cart => {
    if(cart.attributes?.ok_frame_details)return cart;
    let cached;try{cached=JSON.parse(sessionStorage.getItem('ok_checkout_details')||'null');}catch{return cart;}
    if(!cached)return cart;
    if(!cart.items.length){if(cart.token===cached.token)cart.attributes={...cart.attributes,ok_frame_summary:cached.attributes.ok_frame_summary};sessionStorage.removeItem('ok_checkout_details');return cart;}
    const current=totals(cart.items);
    if(cart.token!==cached.token||Object.keys(current).some(id=>!cached.totals[id]||current[id]>cached.totals[id]))return cart;
    const response=await fetch((window.Shopify?.routes?.root||'/')+'cart/update.js',{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({attributes:cached.attributes})});
    if(!response.ok)throw new Error('Detalje okvira nije moguće vratiti. Pokušaj ponovno.');
    return response.json();
  };
  const pendingFrames = new Map();
  const reconcileItems = (group,items,cart) => {
    const before=pendingFrames.get(group);if(!before)return {complete:false,partial:false};
    const now=totals(cart.items),wanted=totals(items);
    return {complete:Object.entries(wanted).every(([id,quantity])=>(now[id]||0)>=(before[id]||0)+quantity),partial:Object.keys(wanted).some(id=>(now[id]||0)>(before[id]||0))};
  };
  const mergeNote = (note,details,previous='') => {
    let manual=String(note || '').replace(/\r\n/g,'\n').trim();
    let from=manual.indexOf(start);
    while(from>=0) {
      const to=manual.indexOf(end,from);
      if(to<0)break;
      manual=manual.slice(0,from)+manual.slice(to+end.length);
      from=manual.indexOf(start);
    }
    for(const value of new Set([previous,details])) {
      const generated=String(value || '').replace(/\r\n/g,'\n').trim();
      if(!generated)continue;
      let offset=0;
      while(offset<=manual.length) {
        const index=manual.indexOf(generated,offset);
        if(index<0)break;
        const after=index+generated.length;
        const beforeBlock=index===0 || manual[index-1]==='\n';
        const afterBlock=after===manual.length || manual[after]==='\n';
        if(beforeBlock && afterBlock)manual=manual.slice(0,index)+manual.slice(after);
        else offset=after;
      }
    }
    return [manual.trim(),String(details || '').trim()].filter(Boolean).join('\n\n');
  };
  const prepareItems = async items => {
    const route=window.Shopify?.routes?.root||'/';
    const response=await fetch(route+'cart.js',{headers:{Accept:'application/json'},cache:'no-store'});
    if(!response.ok)throw new Error('Košaricu nije moguće provjeriti. Pokušaj ponovno.');
    const cart=await restoreCart(await response.json()),saved=records(cart);
    const active=new Set(activeRecords(cart).map(item=>item.group));
    for(const key of Object.keys(saved))if(!active.has(key))delete saved[key];
    const base=items.find(item=>item.properties?.['Broj figurica']!==undefined);
    if(!base)throw new Error('Nedostaju detalji okvira. Pokušaj ponovno.');
    const p=base.properties,group=p._ok_group||p._Grupa||'OK-'+crypto.randomUUID();
    pendingFrames.set(group,totals(cart.items));
    saved[group]={baseVariant:base.id,quantity:base.quantity,title:p.Dizajn||(p['Ideja i opisi figurica']?'Po tvojoj ideji':'Konfigurator'),properties:p};
    const value=JSON.stringify(saved);
    const write=await fetch(route+'cart/update.js',{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({attributes:{ok_frame_details:value}})});
    if(!write.ok)throw new Error('Detalje okvira nije moguće spremiti. Pokušaj ponovno.');
    if((await write.json()).attributes?.ok_frame_details!==value)throw new Error('Nisu spremljeni svi detalji okvira. Pokušaj ponovno.');
    items.forEach(item=>{item.properties={_ok_group:group};});
    if(p['_Pregled dizajna']){
      const url=new URL(p['_Pregled dizajna']);
      if(url.origin!=='https://okviri-designs-api.okviri-pokloni.workers.dev'||!/^\/design\/OK-[A-Z2-9]{8}$/.test(url.pathname)||!url.searchParams.get('token'))throw new Error('Poveznica dizajna nije valjana.');
      base.properties={_ok_group:group,'Otvori dizajn':url.href};
    }
  };
  const saveOrderSummary = async () => {
    const route = window.Shopify?.routes?.root || '/';
    const cartResponse = await fetch(route+'cart.js',{headers:{Accept:'application/json'},cache:'no-store'});
    if(!cartResponse.ok)throw new Error('Podatke narudžbe nije moguće provjeriti. Pokušaj ponovno.');
    const cart = await restoreCart(await cartResponse.json());
    renderCartDetails(cart);
    const field = document.querySelector('[name="note"][form="cart"]');
    const details=summary(cart);
    const note = mergeNote(field ? field.value : cart.note,details,cart.attributes?.ok_frame_summary||'');
    if(note.length>5000)throw new Error('Detalji narudžbe prelaze Shopifyjev limit od 5000 znakova. Skrati tekstove prije nastavka.');
    const oldContactKeys=['Kanal za kontakt','ok_contact_method','ok_contact_language'];
    if(note === (cart.note || '') && details === (cart.attributes?.ok_frame_summary||'') && !oldContactKeys.some(key=>cart.attributes?.[key]))return;
    const response = await fetch(route+'cart/update.js',{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({note,attributes:{ok_frame_summary:details,'Kanal za kontakt':'',ok_contact_method:'',ok_contact_language:''}})});
    if(!response.ok)throw new Error('Napomenu narudžbe nije moguće spremiti. Pokušaj ponovno.');
    if((await response.json()).note!==note)throw new Error('Shopify nije spremio cijelu napomenu. Javi nam se prije nastavka.');
    if(field)field.value=note;
  };
  const finalizeCart = async () => {
    const route=window.Shopify?.routes?.root||'/';
    const response=await fetch(route+'cart.js',{headers:{Accept:'application/json'},cache:'no-store'});
    if(!response.ok)throw new Error('Narudžbu nije moguće provjeriti. Pokušaj ponovno.');
    const cart=await response.json();
    const keys=['ok_frame_details','ok_frame_summary','ok_delivery_preference','Kanal za kontakt','ok_contact_method','ok_contact_language'];
    const attributes=Object.fromEntries(keys.filter(key=>cart.attributes?.[key]).map(key=>[key,cart.attributes[key]]));
    try{sessionStorage.setItem('ok_checkout_details',JSON.stringify({token:cart.token,totals:totals(cart.items),attributes}));}catch{throw new Error('Preglednik ne može privremeno sačuvati detalje. Dopusti pohranu za ovu stranicu pa pokušaj ponovno.');}
    const write=await fetch(route+'cart/update.js',{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({attributes:Object.fromEntries(keys.map(key=>[key,'']))})});
    if(!write.ok)throw new Error('Narudžbu nije moguće pripremiti. Pokušaj ponovno.');
    const saved=await write.json();
    if(saved.note!==cart.note||keys.some(key=>saved.attributes?.[key]))throw new Error('Nije spremljena čista napomena narudžbe. Pokušaj ponovno.');
  };
  let noteSync=Promise.resolve();
  const syncOrderSummary=()=>{noteSync=noteSync.catch(()=>{}).then(saveOrderSummary);return noteSync;};
  let petDialog;
  document.addEventListener('click',event => {
    const link = event.target.closest?.('[data-pet-image-link], .ok-extras__pet-reference a');
    if(!link || !link.href)return;
    event.preventDefault();
    if(!petDialog){
      const en=document.documentElement.lang.startsWith('en');
      petDialog=document.createElement('dialog');
      petDialog.setAttribute('aria-label',en?'Pet selection image':'Slika ljubimaca za odabir');
      petDialog.style.cssText='width:min(640px,94vw);max-width:94vw;max-height:90vh;max-height:90dvh;padding:0;border:0;border-radius:16px;background:#FAFAF7;color:#242424;overflow:hidden;';
      const bar=document.createElement('div');
      bar.style.cssText='display:flex;align-items:center;justify-content:space-between;padding:10px 14px;gap:12px;border-bottom:1px solid #DDEEF5;font:600 15px "DM Sans",sans-serif;';
      const title=document.createElement('span');title.textContent=en?'Choose your pets':'Odaberi ljubimce';
      const close=document.createElement('button');close.type='button';close.textContent=en?'Close ×':'Zatvori ×';
      close.style.cssText='min-height:44px;padding:8px 16px;border:0;border-radius:10px;background:#147D78;color:white;font:600 15px "DM Sans",sans-serif;cursor:pointer;';
      close.addEventListener('click',()=>petDialog.close());bar.append(title,close);
      const content=document.createElement('div');content.style.cssText='overflow:auto;max-height:calc(90vh - 68px);max-height:calc(90dvh - 68px);padding:10px;overscroll-behavior:contain;';
      const img=document.createElement('img');img.style.cssText='display:block;width:100%;height:auto;';img.alt=en?'Numbered pets':'Ljubimci označeni brojevima';
      content.append(img);petDialog.append(bar,content);document.body.append(petDialog);
      petDialog.addEventListener('click',click=>{if(click.target===petDialog)petDialog.close();});
    }
    petDialog.querySelector('img').src=link.href;
    petDialog.showModal();
  });
  let syncing=false,ready=false;
  document.addEventListener('submit',async event => {
    if(event.target.id !== 'cart' || event.submitter?.name !== 'checkout' || ready || event.defaultPrevented)return;
    event.preventDefault();
    if(syncing)return;
    syncing=true;
    const button=event.submitter;
    button.disabled=true;
    let error=document.querySelector('[data-ok-order-note-error]');
    try {
      await syncOrderSummary();
      await finalizeCart();
      ready=true;
      button.disabled=false;
      event.target.requestSubmit(button);
      ready=false;
    } catch(problem) {
      if(!error){error=document.createElement('p');error.dataset.okOrderNoteError='';error.setAttribute('role','alert');button.after(error);}
      error.textContent=document.documentElement.lang.startsWith('en')?'Your order details could not be saved. Please try again.':problem.message;
      error.hidden=false;
    } finally {syncing=false;button.disabled=false;}
  });
  window.OkviriContact = {read,properties,saveCart,prepareItems,reconcileItems,syncOrderSummary,finalizeCart,summary,mergeNote};
  let detailCart;
  const renderCartDetails=cart=>{
    if(cart?.items)detailCart=cart;
    if(!detailCart)return;
    const active=activeRecords(detailCart);
    document.querySelectorAll('[data-ok-frame-details]').forEach(details=>{
      const matches=active.filter(item=>details.dataset.group?item.group===details.dataset.group:String(item.record.baseVariant)===details.dataset.variant);
      if(!matches.length)return;
      const content=details.querySelector('[data-ok-frame-description]');
      const text=matches.map(item=>'Okvir '+(active.indexOf(item)+1)+': '+item.record.title+'\n'+describe(item.record.properties)).join('\n\n');
      if(content.textContent!==text)content.textContent=text;
      if(details.hidden)details.hidden=false;
      let edits=details.parentElement.querySelector('[data-ok-edit-links]');if(!edits){edits=document.createElement('div');edits.dataset.okEditLinks='';details.after(edits)}
      const signature=matches.map(item=>item.group).join('|');if(edits.dataset.signature!==signature){edits.dataset.signature=signature;edits.replaceChildren();matches.forEach(({record})=>{const id=record.properties?._ok_edit_key;if(!id)return;try{const saved=JSON.parse(localStorage.getItem('okviri-edit-'+id)||'null');if(!saved?.state||!saved.path?.startsWith('/')||saved.path.startsWith('//'))return;const link=document.createElement('a');const url=new URL(saved.path,location.origin);url.searchParams.set('edit',id);const preview=new URL(location.href).searchParams.get('preview_theme_id');if(preview)url.searchParams.set('preview_theme_id',preview);link.href=url.pathname+url.search;link.textContent=document.documentElement.lang.startsWith('en')?'Edit design':'Uredi dizajn';link.style.cssText='display:inline-block;margin:10px 0;padding:10px 14px;border:1px solid #147d78;border-radius:8px;color:#147d78;font-weight:700';edits.append(link);const title=details.closest('.cart-item')?.querySelector('.cart-item__name');if(title)title.href=link.href}catch{}})}
    });
  };
  const cartItems=document.querySelector('cart-items');
  if(cartItems)new MutationObserver(()=>renderCartDetails()).observe(cartItems,{childList:true,subtree:true});
  if(document.querySelector('form#cart'))syncOrderSummary().catch(problem=>{
    const error=document.createElement('p');error.dataset.okOrderNoteError='';error.setAttribute('role','alert');error.textContent=problem.message;document.querySelector('#checkout')?.after(error);
  });
})();







